export default function InfoPage() {
  return (
    <div className="container">
      <h1>Information om psykiatrisk vård i Stockholms län</h1>

      <p>
        Den offentligt finansierade psykiatriska vården i Stockholms län är uppdelad i geografiska ansvarsområden, så kallade upptagningsområden, baserade på var man som patient är folkbokförd.
      </p>

      <p>
        I vissa fall är det olika kliniker som har ansvar för psykiatrisk öppenvård respektive slutenvård. Detta beror på att Region Stockholm har beslutat att endast regiondrivna psykiatriska kliniker (Norra Stockholms psykiatri, Psykiatri Nordväst, Psykiatri Sydväst, Psykiatri Södra Stockholm och Psykiatricentrum Södertälje) får bedriva psykiatrisk slutenvård, även kallad heldygnsvård.
      </p>

      <p>
        Fritt vårdval gäller inom den psykiatriska vården i Stockholms län. Det innebär att man som patient har möjlighet att önska vård vid valfri psykiatrisk klinik som har avtal med Region Stockholm, oavsett var i länet man är folkbokförd.
      </p>

      <p>
        Det rekommenderas dock starkt att man i första hand vänder sig till den klinik som har ansvar för det egna geografiska området. Detta beror bland annat på att de olika klinikernas psykiatriska jourenheter inte har möjlighet att göra hembesök utanför sina respektive upptagningsområden.
      </p>
    
    <div className="last-updated">
     Senast uppdaterad: 2026-03-19
    </div>
   </div>
  );
}
